import React from 'react';
import PropTypes from 'prop-types';

import Field from 'zignal-landscape/lib/Field';
import Label from 'zignal-landscape/lib/Label';
import Select from 'zignal-landscape/lib/Select';
import Input from 'zignal-landscape/lib/Input';
import Textarea from 'zignal-landscape/lib/Textarea';
import Checkbox from 'zignal-landscape/lib/Checkbox';
import themeable from 'zignal-landscape/lib/themeable';
import { SOURCE_OPTIONS_URLS, SOURCE_OPTIONS_CONTENT } from '../../StoryAndSourceChecker.ducks';
import find from 'lodash/find';

const STORY_TYPES = [
  {value: 'urls', label: 'URL'},
  {value: 'content', label: 'Story Text'}
];

const textAreaLabel = (sourceTypeOption) => {
  if (sourceTypeOption === 'content') {
    return 'Story Text';
  }
  return 'URL(s)';
};

const textAreaPlaceholder = (sourceTypeOption) => {
  if (sourceTypeOption === 'content') {
    return 'Enter story content';
  }
  return 'Enter each URL you want to check in a new line or paste in a list copied from an email or a spreadsheet';
};

const textAreaErrorMessage = (props) => {
  const { hasExceededLimit } = props;
  if (hasExceededLimit) {
    return 'You can only check 1000 URLs at a time.';
  }
  return '';
};

const StoryCheckerForm = (props) => {
  const { styles, selectedStoryType, storiesToCheck, editStoriesList,
    setStoryType, profiles, selectedProfiles, selectedSource, handleProfilesChange,
    title = '', handleTitleChanged, includeAll, handleIncludeAll, handleSourceSelection } = props;

  const errorMessage = textAreaErrorMessage(props);

  const textAreaElem = selectedStoryType && (
    <Field>
      <Label>
        {textAreaLabel(selectedStoryType)}
      </Label>
      <Textarea
        rows="4"
        className={styles.checkerTextArea}
        value={storiesToCheck}
        onChange={editStoriesList}
        placeholder={textAreaPlaceholder(selectedStoryType)}
        error={errorMessage !== ''}
        errorMessage={errorMessage}
      />
    </Field>
  );

  return (
    <div>
      <div className={styles.storyTypeHorizontalForm}>
        <div className={styles.containerFlexOne}>
          <Field>
            <Label>
              Story Type
            </Label>
            <div className={styles.storyTypeSelectContainer}>
              <Select
                options={STORY_TYPES}
                value={find(STORY_TYPES, {value: selectedStoryType})}
                placeholder="Select an option"
                onChange={(option) => setStoryType(option.value)}
                size="normal"
                showArrow
              />
            </div>
          </Field>
        </div>
        <div className={styles.storyTypeTitle}>
          {selectedStoryType === 'content' ?
            <Field>
              <Label>Title</Label>
              <Input
                placeholder="Optional"
                value={title}
                onChange={handleTitleChanged}
              />
            </Field> : null}
        </div>
      </div>
      <div className={styles.checkerTextAreaContainer}>
        {textAreaElem}
      </div>
      <div>
        {(selectedStoryType) ?
          <Field>
            <Label>Datasets</Label>
            <label className={styles.checkboxLabel}>
              <Checkbox
                checked={includeAll}
                onChange={(event)=> handleIncludeAll({ event, profiles})}
              />
              <span className={styles.checkboxLabelText}>Include All</span>
            </label>
            <Select
              id="profilesField"
              isMulti
              options={profiles.map((p) => ({value: p._id, label: p.name}))}
              value={selectedProfiles.map((p) => ({value: p._id, label: p.name}))}
              onChange={(options) => {
                const newSelectedProfiles = options.map((o) => find(profiles, {_id: o.value}));
                handleProfilesChange({value: newSelectedProfiles, profiles});
              }}
            />
            <div className={styles.sourceLabelSpacer}><Label>Source</Label></div>
            <Select
              id="sourceField"
              options={selectedStoryType === 'content' ? SOURCE_OPTIONS_CONTENT : SOURCE_OPTIONS_URLS}
              value={find(SOURCE_OPTIONS_CONTENT, {value: selectedSource})}
              onChange={(option) => handleSourceSelection({source: option.value})}
            />
          </Field>
          :null}
      </div>
    </div>
  );
};

StoryCheckerForm.propTypes = {
  styles: PropTypes.object,
  selectedStoryType: PropTypes.string,
  hasExceededLimit: PropTypes.bool,
  title: PropTypes.string,
  storiesToCheck: PropTypes.string,
  editStoriesList: PropTypes.func,
  setStoryType: PropTypes.func,
  profiles: PropTypes.array,
  selectedProfiles: PropTypes.array,
  selectedSource: PropTypes.string,
  handleProfilesChange: PropTypes.func,
  handleTitleChanged: PropTypes.func,
  handleSourceSelection: PropTypes.func.isRequired,
  includeAll: PropTypes.bool,
  handleIncludeAll: PropTypes.func,
};

export default themeable(StoryCheckerForm);
export {STORY_TYPES};
